const MAP_MODE_SINGLE = 1 // single reading
const MAP_MODE_MULTI  = 2 // multiple readings and path
const MAP_MODE_ZONE   = 3 // single zone

export {
	MAP_MODE_SINGLE,
	MAP_MODE_MULTI,
	MAP_MODE_ZONE
}



// WEBPACK FOOTER //
// ./src/utils/maps.js